'use strict';

var $ = require('jquery');
var colorbox = require('../lib/plaudit.colorbox.js');
// var lightboxDefaultOptions = require('./siteLightboxOptions.js');
var optionsDefaults = {
	// current: '',
	// fixed: true,
	// initialHeight: 300,
	// initialWidth: 500,
	// maxHeight: '90%',
	// maxWidth: '90%',
	// opacity: .90,
	// scalePhotos: true,
	// speed: 450,
	// transition: 'fade'
}

function formLightbox() {
	var $elem = $('.lenderMarketplaceTable a.btn');
	if ($elem.length == 0) {
		return;
	}

	var options = $.extend({}, optionsDefaults, {
		html: function(){
			var fullHtml = '';
			$.ajax({
				url: $(this).attr('href'),
				success: function(data) {
					var $data = $('#lightboxContent', data);
					fullHtml = '<div id="' + $data.attr('id') + '" class="' + $data.attr('class') + '">';
					$data.each(function() {
						var html = $(this).html();
						if (typeof html === 'string') {
							fullHtml += html;
						}
					});
				},
				async: false
			});
			return fullHtml + '</div>';
		},
		onComplete: function(){
			$.colorbox.resize();
			window.setInterval(function(){
				$.colorbox.resize();
			}, 500);
		}
	});

	$elem.colorbox(options);
}


module.exports = {
	init: function(){
		formLightbox();
	}
}